import { Open_link as OpenLink } from "@unlimited-robotics/ur-ui-kit";
import React from "react";

const Cognishire = () => {
  const params = new URLSearchParams(window.location.search);
  const title = params.get("title");
  const url = params.get("url");
  const back_button = params.get("back_button");

  window.reawer = params;

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
      }}
    >
      <OpenLink
        url={
          url || "https://cognishine.com/he-il/home-practice/97614384-e776-4b26-9bc1-57fadb7a38b3"
        }
        title={title}
        back_button={back_button}
      />
    </div>
  );
};

export default Cognishire;
